import { createAsyncThunk } from '@reduxjs/toolkit';
import segmenterSectionAPIService from '../../services/api_service';
import { setSelectedX, setSelectedY } from 'store/slices/chartSlice';
import { campaignNavigatorUrl } from 'constants';

export const fetchClusterData = createAsyncThunk(
  'segmenter/fetchClusterData',
  async ({ chartId } = {}, { getState, dispatch, rejectWithValue }) => {
    try {
      const { importFileName } = getState().segmenter;
      const data = await segmenterSectionAPIService.fetchClusterData({ input_file: importFileName });

      if (data) {
        if (data.default_x_axis) {
          if (chartId) {
            dispatch(setSelectedX({ chartId, value: data.default_x_axis }));
          } else {
            dispatch(setSelectedX(data.default_x_axis));
          }
        }
        if (data.default_y_axis) {
          if (chartId) {
            dispatch(setSelectedY({ chartId, value: data.default_y_axis }));
          } else {
            dispatch(setSelectedY(data.default_y_axis));
          }
        }
      }

      return data;
    } catch (error) {
      return rejectWithValue(error?.message || 'Error fetching cluster data.');
    }
  }
);

export const fetchImportFiles = createAsyncThunk(
  'segmenter/fetchImportFiles',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { importFileName } = getState().segmenter;
      const fileList = await segmenterSectionAPIService.fetchImportFiles({ input_file: importFileName });
      return fileList;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const exportFileWithInputs = createAsyncThunk(
  'segmenter/exportFileWithInputs',
  async ({ filename, storageType, sasUri, clusterData }, { rejectWithValue }) => {
    try {
      const data = await segmenterSectionAPIService.exportFileApi({
        output_file_name: filename ?? '',
        cluster_output_json: clusterData,
        storage_type: storageType ?? '',
        export_config: { sas_uri: sasUri ?? '' },
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const exportAutoClusterFile = createAsyncThunk(
  'segmenter/exportAutoClusterFile',
  async ({ file }, { rejectWithValue }) => {
    try {

      const FILE_LIMIT = 6 * 1024 * 1024; // ..6mb
      let s3Key = null;

      // ✅ BIG FILE → upload to EC2 → S3
      if (file && file.size > FILE_LIMIT) {

        const formData = new FormData();
        formData.append("file", file);

        const uploadRes = await fetch(`${campaignNavigatorUrl}api/v1/amai/upload_to_s3`, {
          method: "POST",
          body: formData
        });

        const uploadData = await uploadRes.json();
        //if (!uploadRes.ok) throw uploadData;
        s3Key = uploadData.data.s3Key;

      }
      else {
        s3Key = '';
      }

      const data = await segmenterSectionAPIService.exportAutoClusterFileApi({ file, s3Key });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const exportAutoClusterFileFromS3 = createAsyncThunk(
  'segmenter/exportAutoClusterFileFromS3',
  async ({ inputFileName, renamedFile }, { rejectWithValue }) => {
    try {
      const data = await segmenterSectionAPIService.exportAutoClusterFileFromS3Api({ inputFileName: inputFileName, renamedFile: renamedFile });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchRAGFiles = createAsyncThunk(
  'segmenter/fetchRAGFiles',
  async (_, { rejectWithValue }) => {
    try {
      const fileList = await segmenterSectionAPIService.fetchRAGFiles();
      return fileList;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const exportRAGFile = createAsyncThunk(
  'segmenter/exportRAGFile',
  async ({ file }, { rejectWithValue }) => {
    try {
      const data = await segmenterSectionAPIService.exportRAGFileApi({ file });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteRAGFile = createAsyncThunk(
  'segmenter/deleteRAGFile',
  async ({ id }, { rejectWithValue }) => {
    try {
      const data = await segmenterSectionAPIService.deleteRAGFileApi({ id });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const syncRAGFile = createAsyncThunk(
  'segmenter/syncRAGFile',
  async (_, { rejectWithValue }) => {
    try {
      const data = await segmenterSectionAPIService.syncRAGFileApi();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchSummarizedChatDownloadFile = createAsyncThunk(
  'segmenter/fetchSummarizedChatDownloadFile',
  async ({ seg_conversation, filename }, { rejectWithValue }) => {
    try {
      const data = await segmenterSectionAPIService.fetchSummarizedChatDownloadFileApi({ seg_conversation, filename });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const exportFileToS3 = createAsyncThunk(
  'segmenter/exportFileToS3',
  async ({ file, file_name, camp_brief_conversation }, { rejectWithValue }) => {
    try {
      const data = await segmenterSectionAPIService.pushToS3({ file: file, file_name: file_name, camp_brief_conversation: camp_brief_conversation });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const exportClusterFile = createAsyncThunk(
  'segmenter/exportClusterFile',
  async ({ input_file , output_name}, { rejectWithValue }) => {
    try {
      const data = await segmenterSectionAPIService.exportClusterFileApi({ input_file, output_name });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);